/* eslint-disable func-names , array-callback-return */
import { EventEmitter } from 'events';
import _ from 'lodash';
import AppDispatcher from '../dispatcher/AppDispatcher';
import NBAApiUtils from '../utils/NBAApiUtils';
import { CHANGE_EVENT } from '../constants/AppConstants';
import NBAConstants from '../constants/NBAConstants';
import NBAEntity from '../entities/nba/NBAEntity';
import NBASettingsEntity from '../entities/nba/NBASettingsEntity';
import NBABL from '../components/nba/NBABL';

let nbaData = new NBAEntity();
let nbaStatus = 0;
let productData = new NBAEntity();
let productStatus = 0;
let userSetings = new NBASettingsEntity();
let userSettingsStatus = 0;
let splashAckStatus = 0;
let containerAckStatus = 0;
let docallNba = true;
let parsedSplashData = undefined;

const NBAStore = Object.assign({}, EventEmitter.prototype, {
  emitChange() {
    this.emit(CHANGE_EVENT);
  },
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },
  getNBAData() {
    return nbaData;
  },
  getNBAStatus() {
    return nbaStatus;
  },
  getProductBanner() {
    return productData;
  },
  getProductBannerStatus() {
    return productStatus;
  },
  getUserSettings() {
    return userSetings;
  },
  getUserSettingsStatus() {
    return userSettingsStatus;
  },
  getSplashAckStatus() {
    return splashAckStatus;
  },
  getContainerAckStatus() {
    return containerAckStatus;
  },
  getParsedSplashData() {
    return parsedSplashData;
  },
  setParsedSplashData(data) {
    return (parsedSplashData = data);
  },
  doCallNba() {
    return docallNba;
  },
  resetStore() {
    nbaData = new NBAEntity();
    nbaStatus = 0;
    productData = new NBAEntity();
    productStatus = 0;
    userSetings = new NBASettingsEntity();
    userSettingsStatus = 0;
    splashAckStatus = 0;
    containerAckStatus = 0;
    parsedSplashData = undefined;
    docallNba = true;
  },
  resetSplashData() {
    containerAckStatus = 0;
    splashAckStatus = 0;
    parsedSplashData = undefined;
  },
});

NBAStore.dispatchToken = AppDispatcher.register((payload) => {
  const action = payload.action;
  switch (action.actionType) {
    case NBAConstants.REQUEST_NBA_SETTINGS:
      NBAApiUtils.getUserSettingsData();
      break;
    case NBAConstants.REQUEST_NBA_SETTINGS_SUCCESS:
      userSetings = action.data;
      userSettingsStatus = action.status;
      docallNba = false;
      NBABL.callNBAServices(userSetings);
      // NBAStore.emitChange();
      break;
    case NBAConstants.REQUEST_NBA_SETTINGS_ERROR:
      userSettingsStatus = action.status;
      docallNba = true;
      NBABL.callAccountService();
      break;
    case NBAConstants.REQUEST_NBA_DATA:
      NBAApiUtils.getNBAData(action.data);
      break;
    case NBAConstants.REQUEST_NBA_DATA_SUCCESS:
      nbaData.nbaList = _.merge(nbaData.nbaList, action.data.nbaList);
      nbaStatus = action.status;
      docallNba = false;
      NBAStore.emitChange();
      break;
    case NBAConstants.REQUEST_NBA_DATA_ERROR:
      nbaStatus = action.status;
      docallNba = true;
      NBABL.callAccountService();
      break;
    case NBAConstants.REQUEST_SPLASH_DATA_SUCCESS:
      nbaData.nbaList = action.data.nbaList;
      nbaStatus = action.status;
      docallNba = false;
      NBAStore.emitChange();
      break;
    case NBAConstants.REQUEST_SPLASH_DATA_ERROR:
      nbaData.nbaList = {};
      nbaStatus = action.status;
      docallNba = true;
      NBABL.callAccountService();
      break;
    case NBAConstants.REQUEST_NBA_PRODUCT_DATA_SUCCESS:
      productData = action.data;
      productStatus = action.status;
      // docallNba = false;
      NBAStore.emitChange();
      break;
    case NBAConstants.REQUEST_NBA_PRODUCT_DATA_ERROR:
      productStatus = action.status;
      // docallNba = true;
      NBABL.callAccountService();
      break;
    case NBAConstants.REQUEST_SPLASH_ACK:
      NBAApiUtils.setNBAFeedBack(action.accountType, action.payload, 'splash');
      break;
    case NBAConstants.REQUEST_SPLASH_ACK_SUCCESS:
      splashAckStatus = action.status;
      if (splashAckStatus === 200) {
        userSetings.setSplashAcknowledged(true);
        // Clear out any acknowledged splash
        nbaData.nbaList = new NBAEntity();
        NBAStore.emitChange();
      }
      docallNba = true;
      break;
    case NBAConstants.REQUEST_SPLASH_ACK_ERROR:
      NBAStore.setParsedSplashData(undefined);
      NBAStore.resetSplashData();
      splashAckStatus = action.status;
      break;
    case NBAConstants.REQUEST_C_CONTAINER_ACK:
      NBAApiUtils.setNBAFeedBack(
        action.accountType,
        action.payload,
        'nbacontainer'
      );
      break;
    case NBAConstants.REQUEST_C_CONTAINER_ACK_SUCCESS:
      containerAckStatus = action.status;
      docallNba = true;
      NBAStore.emitChange();
      break;
    case NBAConstants.REQUEST_C_CONTAINER_ACK_ERROR:
      containerAckStatus = action.status;
      break;
    case NBAConstants.REQUEST_SPLASH_DATA:
      NBAApiUtils.getSplashData();
      break;
    default: {
      break;
    }
  }
});

export default NBAStore;
